import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_license_plate_planned_asn_totalsService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { licensePlateId: number }): 
  Promise<{ result: { PackagedAmount?: number, GrossWeight?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.licensePlateId)) {
      missingRequiredInParams.push('\'licensePlateId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/datasources/license_plate_planned_asn_totals/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { licensePlateId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { PackagedAmount?: number, GrossWeight?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.licensePlateId)) {
      missingRequiredInParams.push('\'licensePlateId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/datasources/license_plate_planned_asn_totals/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

